'use strict';
angular.module('ngTruncate', [])
    .filter('truncate',
        function() {
            return function(input, chars) {
                if (isNaN(chars)) return input;
                chars = chars - 3;
                if (chars <= 0) return '...';
                if (input && input.length > chars) {
                    input = input.substring(0, chars);

                    while (input.charAt(input.length - 1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }

                    return input + '...';
                }
                return input;
            };
        });